export var phases = [
    {
        name: 'setup',
        stepCount: 3,
    },
    {
        name: 'test',
        stepCount: 23,
    },
    {
        name: 'result',
        stepCount: 2,
    },
];
